import LoginForm from '../auth/LoginForm'

const Login = () => {

  return (
    <LoginForm />
  )
}

export default Login